<template>
  <div class="vacancy-edit-characteristics__section-group">
    <div v-for="param in paramsList"
         :key="param.id"
         class="vacancy-edit-characteristics__section">
      <div class="vacancy-edit-characteristics__section-head">
        <div class="vacancy-edit-characteristics__title-wrap">
<!--          <div class="vacancy-edit-characteristics__ico">-->
<!--            <BaseSvg name="ico-transport" width="1.2rem" height="1.2rem"/>-->
<!--          </div>-->
          <h3 class="vacancy-edit-characteristics__title">{{param.title}}</h3>
        </div>
      </div>
      <div v-if="param.type === 'radio'"
           class="vacancy-edit-characteristics__section-content">
        <div class="vacancy-edit-characteristics__sub-section">
          <BaseRadioList :value="getRadioValueById(param.values, resultParams[param.id])"
                         textKey="title"
                         columns
                         :options="param.values"
                         @input="onRadioInput(param.id, $event)"
                         class="vacancy-edit-characteristics__item"
          />
          <div class="vacancy-edit-characteristics__item">
            <button v-if="!isOpenComment(resultParams[param.id])"
                    @click.prevent="onAddComment(param.id)"
                    class="base-btn  base-btn--outline-grey base-btn--small">
              <BaseSvg name="ico-comment"
                       width="1.3rem"
                       height="1.4rem"
                       style="position: relative; top: 0.1rem"/>
              <span>{{$tNewVacancy('Add a comment')}}</span>
            </button>
            <TranslateFiled v-else
                            :value="resultParams[param.id] && resultParams[param.id].comment"
                            :label="$tNewVacancy('Comment')"
                            textarea
                            rows="5"
                            withFullDelete
                            noJSON
                            @input="onCommentInput(param.id, $event)"
                            @delete="onDeleteComment(param.id)"/>
          </div>
        </div>
      </div>
      <div v-else-if="param.type === 'checkbox'"
           class="vacancy-edit-characteristics__section-content">
        <div class="vacancy-edit-characteristics__sub-section">
          <div class="vacancy-edit-characteristics__item checkbox-list _columns">
            <div class="checkbox-list__list">
              <div class="checkbox-list__list-item"
                   v-for="item in param.values"
                   :key="item.id"
              >
                <BaseCheckbox :checked="checkIsCheckedById(resultParams[param.id], item)"
                              :label="item.title"
                              @input="onCheckboxInput(param.id, item, $event)"
                              class="checkbox-list__item"
                />
              </div>
            </div>
          </div>
          <div class="vacancy-edit-characteristics__item">
            <button v-if="!isOpenComment(resultParams[param.id])"
                    @click.prevent="onAddComment(param.id)"
                    class="base-btn  base-btn--outline-grey base-btn--small">
              <BaseSvg name="ico-comment"
                       width="1.3rem"
                       height="1.4rem"
                       style="position: relative; top: 0.1rem"/>
              <span>{{$tNewVacancy('Add a comment')}}</span>
            </button>
            <TranslateFiled v-else
                            :value="resultParams[param.id] && resultParams[param.id].comment"
                            :label="$tNewVacancy('Comment')"
                            textarea
                            rows="5"
                            withFullDelete
                            noJSON
                            @input="onCommentInput(param.id, $event)"
                            @delete="onDeleteComment(param.id)"/>
          </div>
        </div>
      </div>
      <div v-else-if="param.type === 'range_simple'"
           class="vacancy-edit-characteristics__section-content">
        <div class="vacancy-edit-characteristics__sub-section">
          <div v-for="item in param.values"
               :key="item.id"
               class="vacancy-edit-characteristics__item">
            <SliderRange :value="getSliderValueById(resultParams[param.id], item)"
                         :min="item.range_from"
                         :max="item.range_to"
                         :fromName="$tNewVacancy(item.is_single ? null : 'from')"
                         :toName="$tNewVacancy(item.is_single ? null : 'to')"
                         @input="onSliderInput(param.id, item, $event)"
                         :class="{'vacancy-edit-characteristics__work-time-range': item.is_single }"/>
          </div>
          <div class="vacancy-edit-characteristics__item">
            <button v-if="!isOpenComment(resultParams[param.id])"
                    @click.prevent="onAddComment(param.id)"
                    class="base-btn  base-btn--outline-grey base-btn--small">
              <BaseSvg name="ico-comment"
                       width="1.3rem"
                       height="1.4rem"
                       style="position: relative; top: 0.1rem"/>
              <span>{{$tNewVacancy('Add a comment')}}</span>
            </button>
            <TranslateFiled v-else
                            :value="resultParams[param.id] && resultParams[param.id].comment"
                            :label="$tNewVacancy('Comment')"
                            textarea
                            rows="5"
                            withFullDelete
                            noJSON
                            @input="onCommentInput(param.id, $event)"
                            @delete="onDeleteComment(param.id)"/>
          </div>
        </div>
      </div>
      <div v-else-if="param.type === 'select'"
           class="vacancy-edit-characteristics__section-content">
        <div class="vacancy-edit-characteristics__sub-section">
          <BaseSelect :value="geSelectValueById(param.values, resultParams[param.id])"
                      textKey="title"
                      columns
                      :options="param.values"
                      @input="onSelectInput(param.id, $event)"
                      class="vacancy-edit-characteristics__item _shadow"/>

          <div class="vacancy-edit-characteristics__item">
            <button v-if="!isOpenComment(resultParams[param.id])"
                    @click.prevent="onAddComment(param.id)"
                    class="base-btn  base-btn--outline-grey base-btn--small">
              <BaseSvg name="ico-comment"
                       width="1.3rem"
                       height="1.4rem"
                       style="position: relative; top: 0.1rem"/>
              <span>{{$tNewVacancy('Add a comment')}}</span>
            </button>
            <TranslateFiled v-else
                            :value="resultParams[param.id] && resultParams[param.id].comment"
                            :label="$tNewVacancy('Comment')"
                            textarea
                            rows="5"
                            withFullDelete
                            noJSON
                            @input="onCommentInput(param.id, $event)"
                            @delete="onDeleteComment(param.id)"/>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {mapState} from 'vuex'
  import TranslateFiled from './TranslateFiled'
  import SliderRange from './SliderRange'

  export default {
    components: {
      TranslateFiled,
      SliderRange
    },
    props: {},
    data() {
      return {
        isShowComment: false,
        inputs: {
          comment: null
        }
      }
    },
    computed: {
      ...mapState('vacancyEdit/characteristicsDynamicParams', [
          'muted',
          'resultParams',
          'paramsList',
      ])
    },
    methods: {
      isOpenComment(result) {
        return !!(result && (result.comment || result.isOpenComment))
      },
      onAddComment(paramId) {
        let newValue = JSON.parse(JSON.stringify(this.resultParams[paramId] || {}))

        newValue.isOpenComment = true

        const result = {key: paramId, value: newValue}
        this.$store.commit('vacancyEdit/characteristicsDynamicParams/setResultParams', result)
      },
      onDeleteComment(paramId) {
        let newValue = JSON.parse(JSON.stringify(this.resultParams[paramId] || {}))

        newValue.comment = null
        newValue.isOpenComment = false

        const result = {key: paramId, value: newValue}
        this.$store.commit('vacancyEdit/characteristicsDynamicParams/setResultParams', result)
      },
      onCommentInput(paramId, value) {
        let newValue = JSON.parse(JSON.stringify(this.resultParams[paramId] || {}))

        if (value) {
          newValue.comment = value
        } else {
          newValue.comment = null
        }

        const result = {key: paramId, value: newValue}
        this.$store.commit('vacancyEdit/characteristicsDynamicParams/setResultParams', result)
      },
      getRadioValueById(list, result) {
        if (
            !Array.isArray(list) ||
            !result ||
            !Array.isArray(result.values) ||
            !result.values[0]
        ) return null

        let id = result.values[0].key

        return list.find(el => el.id === id)
      },
      checkIsCheckedById(result, item) {
        if (
            !result ||
            !Array.isArray(result.values)
        ) return false

        return !!result.values.find(el => el.key === item.id)
      },
      getSliderValueById(result, item) {
        if (!item) return null

        let resultValue
        let range

        if (result && Array.isArray(result.values)) {
          resultValue = result.values.find(el => el.key === item.id)
        }

        if (!resultValue) {
          resultValue = {}
        }

        if (item.is_single) {
          range = Array.isArray(resultValue.range) ? [resultValue.range[1]] : [item.range_from]
        } else {
          range = Array.isArray(resultValue.range) ? resultValue.range : [item.range_from, item.range_to]
        }

        return range
      },
      geSelectValueById(list, result) {
        if (
            !Array.isArray(list) ||
            !result ||
            !Array.isArray(result.values) ||
            !result.values[0]
        ) return null

        let id = result.values[0].key

        return list.find(el => el.id === id)
      },
      onRadioInput(paramId, value) {
        let newValue = JSON.parse(JSON.stringify(this.resultParams[paramId] || {}))

        if (value && value.id) {
          newValue.values = [{key: value.id}]
        } else {
          newValue.values = []
        }

        const result = {key: paramId, value: newValue}
        this.$store.commit('vacancyEdit/characteristicsDynamicParams/setResultParams', result)
      },
      onCheckboxInput(paramId, valueItem, value) {
        let newValue = JSON.parse(JSON.stringify(this.resultParams[paramId] || {}))

        if (!Array.isArray(newValue.values)) {
          newValue.values = []
        }

        if (value) {
          newValue.values.push({key: valueItem.id})
        } else if (newValue.values) {
          newValue.values = newValue.values.filter(item => item.key !== valueItem.id)
        }

        const result = {key: paramId, value: newValue}
        this.$store.commit('vacancyEdit/characteristicsDynamicParams/setResultParams', result)
      },
      onSliderInput(paramId, valueItem, value) {
        let newValue = JSON.parse(JSON.stringify(this.resultParams[paramId] || {}))

        if (!Array.isArray(newValue.values)) {
          newValue.values = []
        }

        let resultItem = newValue.values.find(item => item.key === valueItem.id)

        if (!resultItem) {
          resultItem = {
            key: valueItem.id
          }

          newValue.values.push(resultItem)
        }

        if (valueItem.is_single) {
          resultItem.range = [0, value[0]]
        } else if (newValue.values) {
          resultItem.range = value
        }

        const result = {key: paramId, value: newValue}
        this.$store.commit('vacancyEdit/characteristicsDynamicParams/setResultParams', result)
      },
      onSelectInput(paramId, value) {
        let newValue = JSON.parse(JSON.stringify(this.resultParams[paramId] || {}))

        if (value && value.id) {
          newValue.values = [{key: value.id}]
        } else {
          newValue.values = []
        }

        const result = {key: paramId, value: newValue}
        this.$store.commit('vacancyEdit/characteristicsDynamicParams/setResultParams', result)
      },
    }
  }

  // "3":{
  //
  //   "value":[1, 2],
  //
  //       "comment": {
  //     "ua": "test",
  //         "en": "test2"
  //   }
  // },
</script>

<style lang="less">

</style>
